module.exports = __webpack_public_path__ + "img/flutter.ad206431.svg";